/**
 * Apply dynamic escaping of certain vue-i18n special characters, so we do not have to escape these in the translations file.
 * @param translations
 */
export const i18nEscape = (translations: Record<string, string>): Record<string, string> => {
  const result = { ...translations };
  Object.keys(result).forEach((key) => (result[key] = result[key].replace(/(@)([^:\\.])/g, "{'$1'}$2")));
  return result;
};
